// extracted by css-extract-rspack-plugin
export default {"zone":"zone-vv9EpC","active":"active-FNLMSX"};